import React from 'react';
import { connect } from 'react-redux';

import { ReactComponent as ErrorIcon } from '../../assets/images/icons_payment_error.svg';
import PageHeader from '../../components/PageHeader';

export const ResourceNotFoundPage = () => {
  return (
    <div className="container container--space-y">
      <PageHeader title=" Sorry! We can't find that page." />

      <div className="row row--align-middle-small row--align-center">
        <div className="col col--10/16-small">
          <div className="row-spacer">
            The link might be old or the page might have moved. Let&apos;s get you back on track!
          </div>

          <div className="row row--align-bottom-small">
            <div className="col col--auto">
              <a
                className="link-button"
                href={process.env.REACT_APP_PLATFORM_OLD_APPLICATION_START}
                target="_blank"
                rel="noopener noreferrer"
              >
                Your applications
              </a>
            </div>
          </div>
        </div>

        <div className="col col--6/16-small col--4/16-medium col--3/16-large col--align-right-small block--small">
          <ErrorIcon />
        </div>
      </div>
    </div>
  );
};

export default connect(null)(ResourceNotFoundPage);
